(function(angular){
	'use strict';

	angular
		.module('investorDashboard')
		.directive('infiniteScrollTrigger', [
			'$rootScope',
			'$window',
			'RevealService',
			infiniteScrollTriggerFunction
		]);

	function infiniteScrollTriggerFunction(
		$rootScope,
		$window,
		RevealService
	) {
		return {
			restrict: 'A',
			link: function($scope, $element, $attrs) {
				function shouldTriggerEvent() {
					if (RevealService.isTopOfElementInViewport($element[0])) {
						$rootScope.$broadcast('infinite-scroll');
					}
				}

				angular.element($window).on('scroll', shouldTriggerEvent);
			}
		};
	}
})(window.angular);